import { snakeToText } from "@utils/helperFunctions";
import { Quote } from "../types/Quote";

export const getLanguages = (languageFields) => {
  let languages =
    languageFields?.map((language: any) => ({
      [language?.attributes?.["sow-language"]]: "",
    })) || [];

  let objOfLanguages = Object.assign({}, ...languages);
  return objOfLanguages;
};

export const getFormattedQuote = (quote, vendors, lobs): Quote => {
  const vendor = vendors?.find(
    (v) => quote?.relationships?.["vendor"]?.data?.id == v?.id
  );
  const frequency = quote?.attributes?.["billing-frequency"];
  const method = quote?.attributes?.["pricing-model"];
  const lob = lobs?.find(
    (lob) => quote?.relationships?.lob?.data?.id == lob?.id
  );
  const status = quote?.attributes?.["vendor-document-status"];

  return {
    id: String(quote.id),
    description: quote?.attributes?.description || "",
    vendor: vendor
      ? {
          label: vendor.attributes?.["name"],
          value: vendor.id,
        }
      : undefined,
    oneTimeCost: quote?.attributes?.cost || "0.0",
    oneTimeRevenue: quote?.attributes?.price || "0.0",
    markup: quote?.attributes?.markup || "",
    recurringCost: quote?.attributes?.["recurring-cost"] || "0.0",
    recurringRevenue: quote?.attributes?.["recurring-price"] || "0.0",
    lob: lob
      ? {
          label: lob.attributes?.["nested-name"] || lob.attributes?.["name"],
          value: lob.id,
        }
      : undefined,
    totalRevenue: quote?.attributes?.["total-revenue"] || "0",
    billingFrequency: {
      value: frequency,
      label: frequency === "one_time" ? "No" : snakeToText(frequency) || "",
    },
    vendorDocumentStatus: status || "",
    documentPending: status !== "not_applicable" && status !== "accepted",
    revenueCalculationLabel: quote?.attributes?.["revenue-calculation"],
    billingMethod: {
      label: method ? snakeToText(method) : "Time and Materials",
      value: method || "time_and_materials",
    },
    mrrMarkup: quote?.attributes?.["mrr-markup"] || "",
    useServicePricing: quote?.attributes?.["service-pricing"],
  };
};

export const roundToFour = (value) => {
  return Number(Math.round(value * 10000) / 10000);
};

export const calculatePrice = (cost, markup, revenueCalculation) => {
  let markupPct = markup / 100;
  let markupRatio =
    revenueCalculation == "margin" ? markupPct / (1 - markupPct) : markupPct;
  return Math.round(Number(cost * (1 + markupRatio)) * 100) / 100;
};

export const calculateMarkup = (cost, revenue, revenueCalculation) => {
  let profit = revenue - cost;
  let result =
    revenueCalculation == "margin"
      ? 100 * (profit / revenue)
      : 100 * (revenue / cost - 1);
  return roundToFour(result);
};

export const calculateCost = (price, markup, revenueCalculation) => {
  const markupPct = markup / 100;

  let cost;
  if (revenueCalculation === "margin") {
    cost = price * (1 - markupPct);
  } else {
    cost = price / (1 + markupPct);
  }

  return Math.round(Number(cost) * 100) / 100;
};
